import * as yup from 'yup';

export const consolidationSchema = yup.object().shape({
    ScorecardName: yup.string().required('Scorecard name is required'),
    FromDate: yup.date().nullable().required('From date is required').typeError('From date is required'),
    ToDate: yup.date().nullable().required('To date is required').typeError('To date is required')
})
.test(
  'to-date-after-from-date',
  '',
  function (values) {
    const { FromDate, ToDate } = values as {
      FromDate: Date | null;
      ToDate: Date | null;
    };

    if (!FromDate || !ToDate) return true;

    if (new Date(ToDate).getTime() <= new Date(FromDate).getTime()) {
      return this.createError({
        path: 'ToDate',
        message: 'To date must be after From date',
      });
    }

    return true;
  }
);